import { Component, OnInit } from '@angular/core';
import { SearchShoe } from '../search-shoe';
import { Input } from '@angular/core';
import { FavoritesListService } from '../favorites-list/favorites-list.component.service';
import { UserService } from '../user.service';
import { interval } from 'rxjs';

@Component({
  selector: 'app-favorites-list',
  templateUrl: './favorites-list.component.html',
  styleUrls: ['./favorites-list.component.css']
})
export class FavoritesListComponent implements OnInit {

  @Input() public favorites: SearchShoe[];

  constructor(public favoritesListService: FavoritesListService, public userService: UserService) { }

  async updateFavoriteShoes()
  {
    await this.favoritesListService.getFavoritesFromFirestore()
    this.favorites = this.favoritesListService.getFavorites();
  }

  ngOnInit(): void {
    this.favorites = this.favoritesListService.favorites;
    this.userService.currentUser = null;
    console.log(this.userService.currentUser);
    setInterval(() => {
      console.log("Updated favorites");
      this.updateFavoriteShoes()}, 500);
  }
}